import React from 'react'
import { Route, Routes as AppRoutes } from 'react-router-dom'
import AuthLayout from '../layouts/Auth'
import DashboardLayout from '../layouts/Dashboard'
import PresentationLayout from '../layouts/Presentation'
import Page404 from '../pages/auth/Page404'
import {
  authLayoutRoutes,
  dashboardLayoutRoutes_Admin,
  dashboardLayoutRoutes_HAdmin,
  dashboardLayoutRoutes_Owner,
  dashboardLayoutRoutes_User,
  presentationLayoutRoutes,
  dashboardLayoutRoutes_FOwner
} from './index'

const childRoutes = (Layout, routes) =>
  routes.map(({ component: Component, guard, children, path }, index) => {
    const Guard = guard || React.Fragment
    return children ? (
      children.map((element, index) => {
        const Guard = element.guard || React.Fragment
        const ElementComponent = element.component || React.Fragment
        return (
          <Route
            key={index}
            path={element.path}
            exact
            // element={(props) => (
            element={
              <Layout>
                <Guard>
                  {/* <ElementComponent {...props} /> */}
                  <ElementComponent />
                </Guard>
              </Layout>
            }
          />
        )
      })
    ) : Component ? (
      <Route
        key={index}
        path={path}
        exact
        element={
          <Layout>
            <Guard>
              <Component />
            </Guard>
          </Layout>
        }
      />
    ) : null
  })

let dashboardLayoutRoutes = dashboardLayoutRoutes_Owner
function Routes() {
  const usertype = localStorage.getItem('usertype')

  if (usertype === 'Owner') {
    dashboardLayoutRoutes = dashboardLayoutRoutes_Owner
  }
  if (usertype === 'Admin') {
    dashboardLayoutRoutes = dashboardLayoutRoutes_Admin
  }
  if (usertype === 'HAdmin') {
    dashboardLayoutRoutes = dashboardLayoutRoutes_HAdmin
  }
  if (usertype === 'User') {
    dashboardLayoutRoutes = dashboardLayoutRoutes_User
  }
  if (usertype === 'FOwner') {
    dashboardLayoutRoutes = dashboardLayoutRoutes_FOwner
  }

  return (
    <>
      <AppRoutes>
        {childRoutes(DashboardLayout, dashboardLayoutRoutes)}
        {/* {childRoutes(DashboardLayout, protectedRoutes)} */}
        {childRoutes(AuthLayout, authLayoutRoutes)}
        {childRoutes(PresentationLayout, presentationLayoutRoutes)}
        <Route
          path="*"
          element={
            <AuthLayout>
              <Page404 />
            </AuthLayout>
          }
        />
        {/* <Switch>
          {childRoutes(DashboardLayout, dashboardLayoutRoutes)}
          {childRoutes(DashboardLayout, protectedRoutes)}
          {childRoutes(AuthLayout, authLayoutRoutes)}
          {childRoutes(PresentationLayout, presentationLayoutRoutes)}
          <Route
            render={() => (
              <AuthLayout>
                <Page404 />
              </AuthLayout>
            )}
          />
        </Switch> */}
      </AppRoutes>
    </>
  )
}

export default Routes
